import React from 'react';

const ContactSection = () => {
   return (
      <div className="relative overflow-hidden rounded-3xl border border-zinc-200/80 dark:border-zinc-800/80 bg-gradient-to-br from-zinc-900 via-zinc-900 to-emerald-900 dark:from-zinc-950 dark:via-zinc-900 dark:to-emerald-950 p-6 sm:p-8 text-white shadow-soft">
         <div
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
               backgroundImage:
                  'radial-gradient(circle at 80% 0%, rgba(33,227,148,0.45) 0, transparent 45%), radial-gradient(circle at 0% 100%, rgba(99,102,241,0.35) 0, transparent 45%)',
            }}
         />
         <div className="relative">
            <div className="section-eyebrow text-emerald-400">
               <span>Get in touch</span>
            </div>
            <h2 className="mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight">
               Open to new work <span className="text-shimmer">or collaboration.</span>
            </h2>
            <p className="mt-2 text-[13.5px] text-zinc-300 max-w-md">
               If you have an Android app or security project you need help with, feel free to reach out.
               I&apos;ll reply within 24 hours.
            </p>

            <div className="mt-5 flex flex-wrap justify-center gap-3">
               <a
                  href="mailto:tanbir@fixbuildx.com"
                  className="inline-flex items-center gap-2 rounded-full bg-white text-zinc-900 px-5 py-2.5 text-sm font-semibold transition hover:scale-[1.02] hover:shadow-glow"
               >
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                     <rect x="3" y="5" width="18" height="14" rx="2" />
                     <path d="M3 7l9 6 9-6" />
                  </svg>
                  tanbir@fixbuildx.com
               </a>
               <a
                  href="#projects"
                  className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-white/20"
               >
                  See work
               </a>
            </div>

            <div className="mt-6 grid grid-cols-3 gap-3">
               <div className="rounded-xl bg-white/5 ring-1 ring-white/10 p-3 text-center">
                  <p className="font-display text-lg font-bold">24h</p>
                  <p className="text-[10px] uppercase tracking-wider text-zinc-400">Response</p>
               </div>
               <div className="rounded-xl bg-white/5 ring-1 ring-white/10 p-3 text-center">
                  <p className="font-display text-lg font-bold">Open</p>
                  <p className="text-[10px] uppercase tracking-wider text-zinc-400">To Work</p>
               </div>
               <div className="rounded-xl bg-white/5 ring-1 ring-white/10 p-3 text-center">
                  <p className="font-display text-lg font-bold">Global</p>
                  <p className="text-[10px] uppercase tracking-wider text-zinc-400">Remote</p>
               </div>
            </div>
         </div>
      </div>
   );
};

export default ContactSection;
